import BaseButton from "@/components/base/button/BaseButton";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import Warning3D from "@/components/icons/Warning3D";
import { openPublicOffer } from "@/shared/utils/common";

interface AgeConfirmationDialogProps {
  onConfirm: () => void;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

const AgeConfirmationDialog = ({
  onConfirm,
  isOpen,
  onOpenChange,
}: AgeConfirmationDialogProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    onOpenChange(false);
  };

  const handlePrivacyLinkClick = () => {
    openPublicOffer({
      closeApp: true,
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="border-none w-11/12 sm:max-w-md rounded-20 bg-gray-linear"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="absolute-x -top-8">
            <Warning3D />
          </div>
          <DialogTitle className="text-[28px] text-center !mt-[calc(60px-24px)] font-bold text-white leading-130 max-w-[257px] mx-auto">
            {t("age_check_question")}
          </DialogTitle>
        </DialogHeader>
        <p className="text-white text-sm text-center">
          {t("age_check_description")}
        </p>
        <DialogFooter className="!flex flex-col gap-2 !justify-center !items-center !w-full">
          <BaseButton
            onClick={() => {
              handlePrivacyLinkClick();
            }}
            variant="secondary"
            className="w-full"
            vibrate={true}
            vibrationType="soft"
            text={t("not_old_enough")}
          />
          <BaseButton
            onClick={() => {
              onConfirm();
              handleClose();
            }}
            vibrate={true}
            className="w-full"
            vibrationType="soft"
            text={t("age_check_confirm")}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AgeConfirmationDialog;
